import React, { Component } from 'react'
import { Trans } from '@lingui/react'

import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'

import Spacer from 'client/shared/blocks/spacer'
import { Heading } from 'client/shared/blocks/heading'
import { PromoGifts } from 'client/bookmate/blocks/promo-gifts'
import { LayoutColumn } from 'client/shared/blocks/layout-column'

import ProductCard from 'client/bookmate/blocks/product-card'

import {
  CurrentUserSubscriptions,
  Product,
} from 'client/shared/types/subscription'
import { TrialUnavailableHeader } from '../subscription-form/trial-unavailable-header'
import { CurrentUserState } from 'client/shared/types/current-user'

import './subscription.styl'
import { isEmpty } from 'lodash'
import { Loader } from 'client/shared/blocks/loader/loader'

type Props = {
  products: Product[]
  user: CurrentUserState
  userSubscriptions: CurrentUserSubscriptions
} & DecoratorProps

class Subscription extends Component<Props> {
  render(): JSX.Element {
    const {
      isMobileSize,
      app,
      app: { isBookmateApp },
      products,
      user,
      userSubscriptions,
    } = this.props

    const productCards: JSX.Element[] = this.getCards()

    const [masterPlan] = products.filter(product => product.id === 'master')
    const isRedirectedFromFeatured = app.previousLocationHref.includes(
      'featured',
    )

    if (isEmpty(userSubscriptions))
      return (
        <>
          <Spacer size="top-page" />
          <Loader color="gray" kind="big" centered />
          <Spacer size="bottom-page" />
        </>
      )

    return (
      <div className="subscription">
        {masterPlan && !masterPlan.trial && isRedirectedFromFeatured && (
          <TrialUnavailableHeader
            user={user}
            currentPlan={masterPlan}
            isMobileSize={isMobileSize()}
          />
        )}
        <Spacer size={24} />
        <Heading kind="kazimir" centered className="subscription-header">
          <Trans id="subscription.header" />
        </Heading>
        <Spacer size={20} />
        <span className="subscription-header__caption">
          <Trans id="subscription.header_caption" />
        </span>
        <Spacer size={40} />
        <div className="subscription__product-cards">{productCards}</div>
        <Spacer size={32} />
        {!isBookmateApp && (
          <LayoutColumn>
            <PromoGifts query={app.storedQuery} />
            <Spacer size={32} />
          </LayoutColumn>
        )}
      </div>
    )
  }

  getCards(): JSX.Element[] {
    const { products, user, app } = this.props

    return products.map((product: Product) => (
      <ProductCard
        query={app.storedQuery}
        key={product.id}
        product={product}
        single={products.length === 1}
        locale={user.data.locale}
      />
    ))
  }
}

export default uiBox(Subscription)
